import { settings } from '@core/api';
import { useWindowSize } from '@vueuse/core';
import { computed, nextTick, onBeforeUnmount, onMounted, Ref, ref, watch } from 'vue';

function fixMinHeight() {
  const baseCard = document.querySelector('.base-card-info') as HTMLDivElement;

  if (!baseCard) return;

  const screenHeight = window.innerHeight;

  baseCard.style.minHeight = `${screenHeight - 252}px`;
}

export function useCardTableHeightFix(rowCount?: Ref<number>) {
  const { height } = useWindowSize();

  const fixedFooter = ref(false);
  const maxHeight = ref<string | number>('auto');
  const smallHeight = computed(() => height.value <= settings.smallHeight);

  const getParent = () => {
    return document.querySelector('.content-wrapper-with-tabs') as HTMLDivElement;
  };

  const adjust = () => {
    nextTick(() => {
      setTimeout(() => {
        const parent = getParent();
        const table = parent?.querySelector('.el-table') as HTMLDivElement;

        if (!table) return;

        fixMinHeight();

        if (smallHeight.value) {
          parent?.classList.remove('lmw-full');
          maxHeight.value = 529;

          if (rowCount !== undefined && rowCount.value <= 8) {
            table.style.marginBottom = '46px';
            fixedFooter.value = true;
          } else {
            table.style.marginBottom = 'unset';
            fixedFooter.value = false;
          }
        } else {
          parent?.classList.add('lmw-full');
          table.style.marginBottom = 'unset';
          maxHeight.value = 'auto';
          fixedFooter.value = false;
        }
      });
    });
  };

  onMounted(() => {
    adjust();
  });

  onBeforeUnmount(() => {
    const parent = getParent();

    if (parent) parent.classList.remove('lmw-full');
  });

  watch(
    [
      () => height.value,
      () => smallHeight.value,
    ],
    () => {
      adjust();
    },
    { immediate: true },
  );

  return {
    maxHeight,
    fixedFooter,
  };
}
